import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const ThreeDotTwoDotTwo = () => {
  return (
    <ChangelogInstance version="3.2.2" date="2024-12-06">
      <li>
        Actually fixed applied stickers and attached charms in trade offers too.
      </li>
    </ChangelogInstance>
  );
}

export default ThreeDotTwoDotTwo;